export const levels = {
  1: {
    unlocked: true,
    star: 0,
    levelMoves: 6,
    playerMoves: 0,
    id: "Vfc0cQTRMA",
    nextLevel: "2",
    previousLevel: null,
    showingTime: 1.5,
    Images: [
      {
        img: "https://i.ibb.co/NnCYhky/panda.png",
        id: "Lhe44LRTPy",
        showing: false,
      },
      {
        img: "https://i.ibb.co/LdhSdpQ/dog.png",
        id: "m971yAiOJs",
        showing: false,
      },
      {
        img: "https://i.ibb.co/fvYLqGT/elephant.png",
        id: "wxzcrCbSgi",
        showing: false,
      },
      {
        img: "https://i.ibb.co/NnCYhky/panda.png",
        id: "NGNs7lup73",
        showing: false,
      },
      {
        img: "https://i.ibb.co/LdhSdpQ/dog.png",
        id: "YKsATYt7xK",
        showing: false,
      },
      {
        img: "https://i.ibb.co/fvYLqGT/elephant.png",
        id: "sxhnT0Xyv6",
        showing: false,
      },
    ],
  },
  2: {
    unlocked: false,
    star: 0,
    levelMoves: 8,
    playerMoves: 0,
    id: "OwhpOgKcX2",
    nextLevel: "3",
    previousLevel: "1",
    showingTime: 1.5,
    Images: [
      {
        img: "https://i.ibb.co/BN66L8h/horse.png",
        id: "nGShQE14ka",
        showing: false,
      },
      {
        img: "https://i.ibb.co/NnCYhky/panda.png",
        id: "Lhe44LRTPy",
        showing: false,
      },
      {
        img: "https://i.ibb.co/LdhSdpQ/dog.png",
        id: "m971yAiOJs",
        showing: false,
      },
      {
        img: "https://i.ibb.co/fvYLqGT/elephant.png",
        id: "wxzcrCbSgi",
        showing: false,
      },
      {
        img: "https://i.ibb.co/NnCYhky/panda.png",
        id: "NGNs7lup73",
        showing: false,
      },
      {
        img: "https://i.ibb.co/LdhSdpQ/dog.png",
        id: "YKsATYt7xK",
        showing: false,
      },
      {
        img: "https://i.ibb.co/fvYLqGT/elephant.png",
        id: "sxhnT0Xyv6",
        showing: false,
      },
      {
        img: "https://i.ibb.co/BN66L8h/horse.png",
        id: "Eg3CpNUzTd",
        showing: false,
      },
    ],
  },
  3: {
    unlocked: false,
    star: 0,
    levelMoves: 8,
    playerMoves: 0,
    id: "OwhpOgKcX2",
    nextLevel: "4",
    previousLevel: "2",
    showingTime: 1,
    Images: [
      {
        img: "https://i.ibb.co/BN66L8h/horse.png",
        id: "nGShQE14ka",
        showing: false,
      },
      {
        img: "https://i.ibb.co/R3ZK1x1/lion.png",
        id: "Lhe44LRTPy",
        showing: false,
      },
      {
        img: "https://i.ibb.co/LdhSdpQ/dog.png",
        id: "m971yAiOJs",
        showing: false,
      },
      {
        img: "https://i.ibb.co/fvYLqGT/elephant.png",
        id: "wxzcrCbSgi",
        showing: false,
      },
      {
        img: "https://i.ibb.co/R3ZK1x1/lion.png",
        id: "NGNs7lup73",
        showing: false,
      },
      {
        img: "https://i.ibb.co/LdhSdpQ/dog.png",
        id: "YKsATYt7xK",
        showing: false,
      },
      {
        img: "https://i.ibb.co/fvYLqGT/elephant.png",
        id: "sxhnT0Xyv6",
        showing: false,
      },
      {
        img: "https://i.ibb.co/BN66L8h/horse.png",
        id: "Eg3CpNUzTd",
        showing: false,
      },
    ],
  },
  4: {
    unlocked: false,
    star: 0,
    levelMoves: 10,
    playerMoves: 0,
    id: "OwhpOwKcX2",
    nextLevel: "5",
    previousLevel: "3",
    showingTime: 1.5,
    Images: [
      {
        img: "https://i.ibb.co/BN66L8h/horse.png",
        id: "nGShQE14ka",
        showing: false,
      },
      {
        img: "https://i.ibb.co/R3ZK1x1/lion.png",
        id: "Lhe44LRTPy",
        showing: false,
      },
      {
        img: "https://i.ibb.co/LdhSdpQ/dog.png",
        id: "m971yAiOJs",
        showing: false,
      },
      {
        img: "https://i.ibb.co/fvYLqGT/elephant.png",
        id: "wxzcrCbSgi",
        showing: false,
      },
      {
        img: "https://i.ibb.co/R3ZK1x1/lion.png",
        id: "NGNs7lup73",
        showing: false,
      },
      {
        img: "https://i.ibb.co/LdhSdpQ/dog.png",
        id: "YKsATYt7xK",
        showing: false,
      },
      {
        img: "https://i.ibb.co/fvYLqGT/elephant.png",
        id: "sxhnT0Xyv6",
        showing: false,
      },
      {
        img: "https://i.ibb.co/BN66L8h/horse.png",
        id: "Eg3CpNUzTd",
        showing: false,
      },
      {
        img: "https://i.ibb.co/5khLC73/croc.png",
        id: "L2MkAhH8vA",
        showing: false,
      },
      {
        img: "https://i.ibb.co/5khLC73/croc.png",
        id: "euF194OqmG",
        showing: false,
      },
    ],
  },
  5: {
    unlocked: false,
    star: 0,
    levelMoves: 10,
    playerMoves: 0,
    id: "OwhpOwKmX9",
    nextLevel: "6",
    previousLevel: "4",
    showingTime: 1,
    Images: [
      {
        img: "https://i.ibb.co/BN66L8h/horse.png",
        id: "nGShQE14ka",
        showing: false,
      },
      {
        img: "https://i.ibb.co/R3ZK1x1/lion.png",
        id: "Lhe44LRTPy",
        showing: false,
      },
      {
        img: "https://i.ibb.co/NnCYhky/panda.png",
        id: "m971yAiOJs",
        showing: false,
      },
      {
        img: "https://i.ibb.co/fvYLqGT/elephant.png",
        id: "wxzcrCbSgi",
        showing: false,
      },
      {
        img: "https://i.ibb.co/R3ZK1x1/lion.png",
        id: "NGNs7lup73",
        showing: false,
      },
      {
        img: "https://i.ibb.co/NnCYhky/panda.png",
        id: "YKsATYt7xK",
        showing: false,
      },
      {
        img: "https://i.ibb.co/fvYLqGT/elephant.png",
        id: "sxhnT0Xyv6",
        showing: false,
      },
      {
        img: "https://i.ibb.co/BN66L8h/horse.png",
        id: "Eg3CpNUzTd",
        showing: false,
      },
      {
        img: "https://i.ibb.co/5khLC73/croc.png",
        id: "L2MkAhH8vA",
        showing: false,
      },
      {
        img: "https://i.ibb.co/5khLC73/croc.png",
        id: "euF194OqmG",
        showing: false,
      },
    ],
  },
  6: {
    unlocked: false,
    star: 0,
    levelMoves: 12,
    playerMoves: 0,
    id: "msXifJtPCX",
    nextLevel: "7",
    previousLevel: "5",
    showingTime: 1.5,
    Images: [
      {
        img: "https://i.ibb.co/BN66L8h/horse.png",
        id: "nGShQE14ka",
        showing: false,
      },
      {
        img: "https://i.ibb.co/R3ZK1x1/lion.png",
        id: "Lhe44LRTPy",
        showing: false,
      },
      {
        img: "https://i.ibb.co/NnCYhky/panda.png",
        id: "m971yAiOJs",
        showing: false,
      },
      {
        img: "https://i.ibb.co/fvYLqGT/elephant.png",
        id: "wxzcrCbSgi",
        showing: false,
      },
      {
        img: "https://i.ibb.co/R3ZK1x1/lion.png",
        id: "NGNs7lup73",
        showing: false,
      },
      {
        img: "https://i.ibb.co/NnCYhky/panda.png",
        id: "YKsATYt7xK",
        showing: false,
      },
      {
        img: "https://i.ibb.co/fvYLqGT/elephant.png",
        id: "sxhnT0Xyv6",
        showing: false,
      },
      {
        img: "https://i.ibb.co/BN66L8h/horse.png",
        id: "Eg3CpNUzTd",
        showing: false,
      },
      {
        img: "https://i.ibb.co/5khLC73/croc.png",
        id: "L2MkAhH8vA",
        showing: false,
      },
      {
        img: "https://i.ibb.co/5khLC73/croc.png",
        id: "euF194OqmG",
        showing: false,
      },
      {
        img: "https://i.ibb.co/8m4hvg4/cat.png",
        id: "IbBmbu7OEG",
        showing: false,
      },
      {
        img: "https://i.ibb.co/8m4hvg4/cat.png",
        id: "WgaVSlBkqK",
        showing: false,
      },
    ],
  },
  7: {
    unlocked: false,
    star: 0,
    levelMoves: 12,
    playerMoves: 0,
    id: "msXifJtPCX",
    nextLevel: "8",
    previousLevel: "6",
    showingTime: 1,
    Images: [
      {
        img: "https://i.ibb.co/BN66L8h/horse.png",
        id: "nGShQE14ka",
        showing: false,
      },
      {
        img: "https://i.ibb.co/zHX1sYB/rat.png",
        id: "Lhe44LRTPy",
        showing: false,
      },
      {
        img: "https://i.ibb.co/NnCYhky/panda.png",
        id: "m971yAiOJs",
        showing: false,
      },
      {
        img: "https://i.ibb.co/fvYLqGT/elephant.png",
        id: "wxzcrCbSgi",
        showing: false,
      },
      {
        img: "https://i.ibb.co/zHX1sYB/rat.png",
        id: "NGNs7lup73",
        showing: false,
      },
      {
        img: "https://i.ibb.co/NnCYhky/panda.png",
        id: "YKsATYt7xK",
        showing: false,
      },
      {
        img: "https://i.ibb.co/fvYLqGT/elephant.png",
        id: "sxhnT0Xyv6",
        showing: false,
      },
      {
        img: "https://i.ibb.co/BN66L8h/horse.png",
        id: "Eg3CpNUzTd",
        showing: false,
      },
      {
        img: "https://i.ibb.co/5khLC73/croc.png",
        id: "L2MkAhH8vA",
        showing: false,
      },
      {
        img: "https://i.ibb.co/5khLC73/croc.png",
        id: "euF194OqmG",
        showing: false,
      },
      {
        img: "https://i.ibb.co/8m4hvg4/cat.png",
        id: "IbBmbu7OEG",
        showing: false,
      },
      {
        img: "https://i.ibb.co/8m4hvg4/cat.png",
        id: "WgaVSlBkqK",
        showing: false,
      },
    ],
  },
  8: {
    unlocked: false,
    star: 0,
    levelMoves: 14,
    playerMoves: 0,
    id: "msXiqmtPiX",
    nextLevel: "9",
    previousLevel: "7",
    showingTime: 2,
    Images: [
      {
        img: "https://i.ibb.co/BN66L8h/horse.png",
        id: "nGShQE14ka",
        showing: false,
      },
      {
        img: "https://i.ibb.co/zHX1sYB/rat.png",
        id: "Lhe44LRTPy",
        showing: false,
      },
      {
        img: "https://i.ibb.co/NnCYhky/panda.png",
        id: "m971yAiOJs",
        showing: false,
      },
      {
        img: "https://i.ibb.co/fvYLqGT/elephant.png",
        id: "wxzcrCbSgi",
        showing: false,
      },
      {
        img: "https://i.ibb.co/zHX1sYB/rat.png",
        id: "NGNs7lup73",
        showing: false,
      },
      {
        img: "https://i.ibb.co/NnCYhky/panda.png",
        id: "YKsATYt7xK",
        showing: false,
      },
      {
        img: "https://i.ibb.co/fvYLqGT/elephant.png",
        id: "sxhnT0Xyv6",
        showing: false,
      },
      {
        img: "https://i.ibb.co/BN66L8h/horse.png",
        id: "Eg3CpNUzTd",
        showing: false,
      },
      {
        img: "https://i.ibb.co/5khLC73/croc.png",
        id: "L2MkAhH8vA",
        showing: false,
      },
      {
        img: "https://i.ibb.co/5khLC73/croc.png",
        id: "euF194OqmG",
        showing: false,
      },
      {
        img: "https://i.ibb.co/8m4hvg4/cat.png",
        id: "IbBmbu7OEG",
        showing: false,
      },
      {
        img: "https://i.ibb.co/8m4hvg4/cat.png",
        id: "WgaVSlBkqK",
        showing: false,
      },
      {
        img: "https://i.ibb.co/LdhSdpQ/dog.png",
        id: "ICoMfFFsrj",
        showing: false,
      },
      {
        img: "https://i.ibb.co/LdhSdpQ/dog.png",
        id: "X0i1fC9wJ3",
        showing: false,
      },
    ],
  },
  9: {
    unlocked: false,
    star: 0,
    levelMoves: 14,
    playerMoves: 0,
    id: "msXiqmtPoX",
    nextLevel: "10",
    previousLevel: "8",
    showingTime: 1.5,
    Images: [
      {
        img: "https://i.ibb.co/BN66L8h/horse.png",
        id: "nGShQE14ka",
        showing: false,
      },
      {
        img: "https://i.ibb.co/zHX1sYB/rat.png",
        id: "Lhe44LRTPy",
        showing: false,
      },
      {
        img: "https://i.ibb.co/NnCYhky/panda.png",
        id: "m971yAiOJs",
        showing: false,
      },
      {
        img: "https://i.ibb.co/fvYLqGT/elephant.png",
        id: "wxzcrCbSgi",
        showing: false,
      },
      {
        img: "https://i.ibb.co/zHX1sYB/rat.png",
        id: "NGNs7lup73",
        showing: false,
      },
      {
        img: "https://i.ibb.co/NnCYhky/panda.png",
        id: "YKsATYt7xK",
        showing: false,
      },
      {
        img: "https://i.ibb.co/fvYLqGT/elephant.png",
        id: "sxhnT0Xyv6",
        showing: false,
      },
      {
        img: "https://i.ibb.co/BN66L8h/horse.png",
        id: "Eg3CpNUzTd",
        showing: false,
      },
      {
        img: "https://i.ibb.co/5khLC73/croc.png",
        id: "L2MkAhH8vA",
        showing: false,
      },
      {
        img: "https://i.ibb.co/5khLC73/croc.png",
        id: "euF194OqmG",
        showing: false,
      },
      {
        img: "https://i.ibb.co/8m4hvg4/cat.png",
        id: "IbBmbu7OEG",
        showing: false,
      },
      {
        img: "https://i.ibb.co/8m4hvg4/cat.png",
        id: "WgaVSlBkqK",
        showing: false,
      },
      {
        img: "https://i.ibb.co/LdhSdpQ/dog.png",
        id: "ICoMfFFsrj",
        showing: false,
      },
      {
        img: "https://i.ibb.co/LdhSdpQ/dog.png",
        id: "X0i1fC9wJ3",
        showing: false,
      },
    ],
  },
  10: {
    unlocked: false,
    star: 0,
    levelMoves: 16,
    playerMoves: 0,
    id: "msXiqmtPfX",
    nextLevel: "11",
    previousLevel: "9",
    showingTime: 2,
    Images: [
      {
        img: "https://i.ibb.co/BN66L8h/horse.png",
        id: "nGShQE14ka",
        showing: false,
      },
      {
        img: "https://i.ibb.co/zHX1sYB/rat.png",
        id: "Lhe44LRTPy",
        showing: false,
      },
      {
        img: "https://i.ibb.co/NnCYhky/panda.png",
        id: "m971yAiOJs",
        showing: false,
      },
      {
        img: "https://i.ibb.co/fvYLqGT/elephant.png",
        id: "wxzcrCbSgi",
        showing: false,
      },
      {
        img: "https://i.ibb.co/zHX1sYB/rat.png",
        id: "NGNs7lup73",
        showing: false,
      },
      {
        img: "https://i.ibb.co/NnCYhky/panda.png",
        id: "YKsATYt7xK",
        showing: false,
      },
      {
        img: "https://i.ibb.co/fvYLqGT/elephant.png",
        id: "sxhnT0Xyv6",
        showing: false,
      },
      {
        img: "https://i.ibb.co/BN66L8h/horse.png",
        id: "Eg3CpNUzTd",
        showing: false,
      },
      {
        img: "https://i.ibb.co/5khLC73/croc.png",
        id: "L2MkAhH8vA",
        showing: false,
      },
      {
        img: "https://i.ibb.co/5khLC73/croc.png",
        id: "euF194OqmG",
        showing: false,
      },
      {
        img: "https://i.ibb.co/8m4hvg4/cat.png",
        id: "IbBmbu7OEG",
        showing: false,
      },
      {
        img: "https://i.ibb.co/8m4hvg4/cat.png",
        id: "WgaVSlBkqK",
        showing: false,
      },
      {
        img: "https://i.ibb.co/LdhSdpQ/dog.png",
        id: "ICoMfFFsrj",
        showing: false,
      },
      {
        img: "https://i.ibb.co/LdhSdpQ/dog.png",
        id: "X0i1fC9wJ3",
        showing: false,
      },
      {
        img: "https://i.ibb.co/R3ZK1x1/lion.png",
        id: "PoH5ujmQSb",
        showing: false,
      },
      {
        img: "https://i.ibb.co/R3ZK1x1/lion.png",
        id: "WLabGpZIAv",
        showing: false,
      },
    ],
  },
  11: {
    unlocked: false,
    star: 0,
    levelMoves: 16,
    playerMoves: 0,
    id: "msXiqmtPCX",
    nextLevel: "12",
    previousLevel: "10",
    showingTime: 1,
    Images: [
      {
        img: "https://i.ibb.co/BN66L8h/horse.png",
        id: "nGShQE14ka",
        showing: false,
      },
      {
        img: "https://i.ibb.co/zHX1sYB/rat.png",
        id: "Lhe44LRTPy",
        showing: false,
      },
      {
        img: "https://i.ibb.co/NnCYhky/panda.png",
        id: "m971yAiOJs",
        showing: false,
      },
      {
        img: "https://i.ibb.co/fvYLqGT/elephant.png",
        id: "wxzcrCbSgi",
        showing: false,
      },
      {
        img: "https://i.ibb.co/zHX1sYB/rat.png",
        id: "NGNs7lup73",
        showing: false,
      },
      {
        img: "https://i.ibb.co/NnCYhky/panda.png",
        id: "YKsATYt7xK",
        showing: false,
      },
      {
        img: "https://i.ibb.co/fvYLqGT/elephant.png",
        id: "sxhnT0Xyv6",
        showing: false,
      },
      {
        img: "https://i.ibb.co/BN66L8h/horse.png",
        id: "Eg3CpNUzTd",
        showing: false,
      },
      {
        img: "https://i.ibb.co/5khLC73/croc.png",
        id: "L2MkAhH8vA",
        showing: false,
      },
      {
        img: "https://i.ibb.co/5khLC73/croc.png",
        id: "euF194OqmG",
        showing: false,
      },
      {
        img: "https://i.ibb.co/8m4hvg4/cat.png",
        id: "IbBmbu7OEG",
        showing: false,
      },
      {
        img: "https://i.ibb.co/8m4hvg4/cat.png",
        id: "WgaVSlBkqK",
        showing: false,
      },
      {
        img: "https://i.ibb.co/LdhSdpQ/dog.png",
        id: "ICoMfFFsrj",
        showing: false,
      },
      {
        img: "https://i.ibb.co/LdhSdpQ/dog.png",
        id: "X0i1fC9wJ3",
        showing: false,
      },
      {
        img: "https://i.ibb.co/R3ZK1x1/lion.png",
        id: "PoH5ujmQSb",
        showing: false,
      },
      {
        img: "https://i.ibb.co/R3ZK1x1/lion.png",
        id: "WLabGpZIAv",
        showing: false,
      },
    ],
  },
};

// const me = `

// https://i.ibb.co/NnCYhky/panda.png
// https://i.ibb.co/zHX1sYB/rat.png
// https://i.ibb.co/8m4hvg4/cat.png
// https://i.ibb.co/5khLC73/croc.png
// https://i.ibb.co/LdhSdpQ/dog.png
// https://i.ibb.co/fvYLqGT/elephant.png
// https://i.ibb.co/BN66L8h/horse.png
// https://i.ibb.co/R3ZK1x1/lion.png
// `;
// const unshuffledImg = [
//   { img: cat, id: "Lhe44LRTPy", showing: false },
//   { img: dog, id: "m971yAiOJs", showing: false },
//   { img: elephant, id: "wxzcrCbSgi", showing: false },
//   { img: horse, id: "nGShQE14ka", showing: false },
//   { img: lion, id: "sOPkRF9LUm", showing: false },
//   { img: panda, id: "I1I3oVEoyW", showing: false },
//   { img: croc, id: "ScBwLVxLEL", showing: false },
//   { img: rat, id: "zMbvb3jAzg", showing: false },
//   { img: cat, id: "jmFoEOuJK9", showing: false },
//   { img: dog, id: "YKsATYt7xK", showing: false },
//   { img: elephant, id: "sxhnT0Xyv6", showing: false },
//   { img: horse, id: "Eg3CpNUzTd", showing: false },
//   { img: lion, id: "fjC2mqoBdZ", showing: false },
//   { img: panda, id: "NGNs7lup73", showing: false },
//   { img: croc, id: "OtXc2HJ6Md", showing: false },
//   { img: rat, id: "zfuyoTxNNl", showing: false },
// ];
// con;
